import Column from '@components/Column';
import Skeleton from '@components/Skeleton';
import { css } from '@emotion/react';
import useAppCustom from '@hooks/useAppCustom';
import { Fragment } from 'react';

function ItemSkeletons() {
    return (
        <Fragment>
            {Array.from({ length: 12 }).map((_, idx) => (
                <ItemSkeleton key={`item-sk=${idx}`} />
            ))}
        </Fragment>
    );
}

function ItemSkeleton() {
    const { itemImageShape } = useAppCustom().items;
    return (
        <Column fullWidth spacing={2}>
            <Skeleton width='100%'
                shape={itemImageShape === 'CIRCLE' ? 'circle' : 'block'}
                css={css`aspect-ratio: 1;  height: auto;`}
            />
            <Column fullWidth align='center' spacing={0.5}>
                <Skeleton width={80} height={16} />
                <Skeleton width={72} height={22} />
            </Column>
        </Column>
    );
}

export default ItemSkeletons;
